import { useState } from 'react';
import { RenderConfigScreenCtx } from 'datocms-plugin-sdk';
import { Canvas, Button } from 'datocms-react-ui';
import 'datocms-react-ui/styles.css';

type Props = {
  ctx: RenderConfigScreenCtx;
};

// Older installs saved these (search endpoint and API key); the credentials now
// live server-side, so this screen only offers to purge them.
const LEGACY_PARAMETER_KEYS = [
  'brandfolderEndpoint',
  'brandfolderApiKey',
];

export default function ConfigScreen({ ctx }: Props) {
  const [hasLegacyParameters, setHasLegacyParameters] = useState(() =>
    LEGACY_PARAMETER_KEYS.some((key) => key in ctx.plugin.attributes.parameters)
  );

  const handleClearLegacyParameters = async () => {
    await ctx.updatePluginParameters({});
    setHasLegacyParameters(false);
    ctx.notice('Legacy credentials removed from the plugin parameters.');
  };

  return (
    <Canvas ctx={ctx}>
      <p>
        This plugin needs no configuration. It talks to Brandfolder through the
        same-origin <code>/api/brandfolder-proxy</code> function, which holds the
        Brandfolder API key server-side.
      </p>
      {hasLegacyParameters && (
        <>
          <p>
            This installation still stores settings from the old setup (search
            endpoint and API key). They are no longer used — remove them so the
            key is no longer saved in DatoCMS.
          </p>
          <Button
            buttonType="primary"
            onClick={handleClearLegacyParameters}
          >
            Remove legacy credentials
          </Button>
        </>
      )}
    </Canvas>
  );
}
